export const AI_SUMMARIES_FLAG = "ai-summaries-enabled";
export function isAiSummariesRolledOut(flags) {
    return (flags === null || flags === void 0 ? void 0 : flags[AI_SUMMARIES_FLAG]) === true;
}
